import TaggableData from "./TaggableData";
import ObjectData from "./ObjectData";
import StoreManager from "../managers/StoreManager";

export const LinkType = {
    homepage: 'homepage',
    wikipedia: 'wikipedia',
    encyclopedia: 'encyclopedia',
    socialMedia: 'socialMedia',
    video: 'video',
    image: 'image',
    sendMessage: 'sendMessage',
    openingTime: 'openingTime',
    navigate: 'navigate'
}

export const WebLinkIcons = {
    [LinkType.homepage]: 'fas fa-globe',
    [LinkType.wikipedia]: 'fab fa-wikipedia-w',
    [LinkType.encyclopedia]: 'fas fa-book',
    [LinkType.socialMedia]: 'fas fa-icons',
    [LinkType.video]: 'fad fa-film',
    [LinkType.image]: 'far fa-image',
    [LinkType.sendMessage]: 'fas fa-mail-bulk',
    [LinkType.openingTime]: 'fas fa-business-time',
    [LinkType.navigate]: 'fa fa-route'
};


export default class Media extends TaggableData {

    constructor (media) {
        if (media instanceof Media) return media;
        super(media);
    }

    static get mainAvatarMediaId() {return "DEFA617A-0000-0000-0000-000000000000"}

    get objectId() {return this._data.objectId};

    get mediaId() {return this._data.mediaId};

    get parentObject() {
        return this.isSubTrack ? (this.parent || {}).parent : this.parent
    }

    get mediaType() {return this.tags.MediaType ||this._data.mediaType || 'speak'}

    get textData() {return this._data.textData || ''}

    get fileData() {return this._data.fileData || null}

    get imageData() {return this._data.fileData ? 'data:image/png;base64,' + this._data.fileData : null}

    get textFileId() {return this._data.textFileId || ''}

    get fileId() {return this._data.fileId || null}

    set textData(val) {this._data.textData  = val}

    set fileData(val) {this._data.fileData = val}

    get isSpeak() {return this.mediaType === 'speak' /*&& (this.fileId || this.textFileId)*/}

    get isPlayable() {return this.isSpeak && (this.fileId || this.textFileId)}

    get isAvatar() {return this.mediaType === 'avatar'}

    get isMainAvatar() {
        const object = this.parentObject

        if (this.mediaType !== "avatar" || !object) {
            return false
        }

        const mainAvatarId = object.tags.AvatarMediaId || Media.mainAvatarMediaId
        return this.mediaId === mainAvatarId
    }

    get isLink() {return this.mediaType === 'webLink'}

    get isTextDoc() {return this.mediaType === 'textDoc'}

    get linkIcon() {return WebLinkIcons[this.tags.LinkType] || null}

    get linkType() {return this.tags.LinkType || LinkType.homepage}

    isChildOf(parentTrack) {return this.tags.ParentSoundtrack === parentTrack.mediaId}

    get getDescription() {
        return this.tags.Description || (this.parent ? (this.parent.description ? this.parent.description(this.language) : this.parent.getDescription) || '' : '');
    }

    get parentDescription() {
        // Parent description on the same language or null. If description the same as parent's - returns null

        if (!this.parent) return null;

        if (this.parent instanceof ObjectData) {
            const objectDescription = this.parent.tags[`Description_${this.language}`] || null;

            return objectDescription !== this.getDescription ? objectDescription : null;
        }

        return this.getDescription !== this.parent.tags.Description
            ? this.parent.tags.Description
            : null
    }

    // ------------------------------------

    get isSubTrack() {
        return !!this.tags.ParentSoundtrack;
    }

    get language() {
        return this.isSubTrack ? (this.parent ? this.parent.language : null) : this.tags.Language;
    }

    get isAllowedForWeb() {
        return !(this.tags.TargetType_web && this.tags.TargetType_web === 'false');
    }

    static sortByPrefPrevTag(list) {
         const sort = () => {
             let listAffected = false;

             list.forEach((it, ind, list) => {
                 if (!it.tags.PrefPrevSpeakId) return;

                 const prefIndex = list.findIndex(s => s.mediaId === it.tags.PrefPrevSpeakId);
                 if (prefIndex < 0) return;
                 if (prefIndex + 1 === ind) return;

                 listAffected = true;
                 list.splice(ind, 1);
                 list.splice(prefIndex + 1, 0, it);
             });
             // console.log(listAffected);
             return listAffected;
         };

         let attemptCount = 0;
         do {
             if (attemptCount > list.length) {
                 console.log('WRONG ORDERING', list);
                 break;
             }
             attemptCount++;
         } while (sort());

        return list;
    }

    get avatarId() {
        return this.tags.AvatarMediaId || this.parent.tags.AvatarMediaId || null;
    }

    get avatarData() {
        if (!this.avatarId) return null;

        const avatarMedia = this.parentObject.mediaEntries.find(it => it.mediaId === this.avatarId);
        if (!avatarMedia || !avatarMedia.fileData) return null;

        return avatarMedia.fileData;
    }

    get lecturerObjectId() {
        if (this.tags.AuthorObjectId) {
            StoreManager.downloadObjectToList(this.tags.AuthorObjectId).then()
            return this.tags.AuthorObjectId;
        }

        return this.parent.isSpeak ? (this.parent.tags.AuthorObjectId || null) : null;
    }

    get ignoreLang() {
        return !!this.tags.IgnoreLang
    }

}
